import { useRouter } from "next/router"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useGeneralStore } from "store"

function Footer() {
  const { footerData } = useGeneralStore()
  const Router = useRouter()
  const { locale } = Router

  return (
    <div className="footer">
      <div className="container">
        <div className="footer-main py-5">
          <div className="row">
            <div className="col-md-4 col-address">
              <h6 className="title">{footerData?.company_name}</h6>
              <p className="address">
                {footerData?.company_address_line1}
                <br /> {footerData?.company_address_line2}
              </p>
            </div>
            <div className="col-md-6 col-link">
              <div className="row">
                <div className="col-6 col-md-4">
                  <Link href="/about">{translations[`about_${locale}`]}</Link>
                </div>
                <div className="col-6 col-md-4">
                  <Link href="/career">{translations[`career_${locale}`]}</Link>
                </div>
              </div>
              <div className="row">
                <div className="col-6 col-md-4">
                  <Link href="/newsroom">{translations[`news_${locale}`]}</Link>
                </div>
                <div className="col-6 col-md-4">
                  <Link href="/contact-us">
                    {translations[`contact_us_${locale}`]}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-social">
              <Link target="_blank" href={footerData?.instagram_url}>
                <i className="aib ai-instagram" />
              </Link>
              <Link target="_blank" href={footerData?.twitter_url}>
                <i className="aib ai-x" />
              </Link>
              <Link target="_blank" href={footerData?.facebook_url}>
                <i className="aib ai-facebook" />
              </Link>
              <Link target="_blank" href={footerData?.youtube_url}>
                <i className="aib ai-youtube" />
              </Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom py-3 py-md-5">
          <div className="row">
            <div className="col-md-6 col-copyright">
              Copyright © {new Date().getFullYear()}{" "}
              <br className="d-md-none" /> PT Nusantara Sejahtera Raya Tbk
            </div>
            <div className="col-md-6 col-tnc">
              {/* <Link href="/terms-and-conditions">
                {translations[`terms_conditions_${locale}`]}
              </Link>
              <Link href="/privacy-policy">
                {translations[`privacy_policy_${locale}`]}
              </Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
